import DocumentTitle from '~/components/DocumentTitle';
import withAuthRequired from '~/components/withAuthRequired';
import { USER_ROLES } from '~/constants';
import { routes } from '~/core/router';
import { LoggedLayout } from '~/layouts/LoggedLayout';
import { SearchContent } from '~/screens/SearchContent/SearchContent';

const SearchContentPage = () => (
  <LoggedLayout __css={{ '& > div': { paddingTop: '0' } }}>
    <DocumentTitle>Search Content</DocumentTitle>
    <SearchContent pathname={routes.contentSearch} />
  </LoggedLayout>
);

export default withAuthRequired(SearchContentPage, {
  roles: [USER_ROLES.talentManager, USER_ROLES.creator],
});
